import { cn } from "../../../lib/utils"
import coverEdgeClosedImg from "./coverEdgeClosed.png"

interface CoverBookEdgeProps {
  albumDirection?: string
  isHovered: boolean
}

export const CoverBookEdge: React.FC<CoverBookEdgeProps> = ({
  albumDirection = "RTL",
  isHovered,
}) => {
  return (
    <div
      className={cn(
        "absolute top-0 bottom-0 w-3 pointer-events-none z-[2]",
        "opacity-40 transition-opacity duration-300",
        isHovered && "opacity-60",
        albumDirection === "RTL" ? "right-0" : "left-0 scale-x-[-1]"
      )}
      style={{
        backgroundImage: `url(${coverEdgeClosedImg})`,
        backgroundRepeat: "repeat-y",
        backgroundSize: "100% auto",
        backgroundPosition: "center",
      }}
    />
  )
}
